import React from 'react';
import { DialogContentStyled, Label, LeftContentWrapper, RightContentWrapper } from 'components/Dialog/DialogContent';
import { LeftContent } from 'components/Dialog/DialogLeftContent';
import { Bottom, BottomActions, ConnectButton, RightForm } from 'components/Dialog/DialogRightContent';
import { ErrorMessage, Input, InputGrid } from 'components/Form';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useAppStore } from 'stores/appStore';
import { showAlert } from 'components/Alert';
import { getTadaAuthorizeUrl } from 'api/marketPlaces';
import { DialogProps } from 'interfaces/Props';
import { channels } from 'shared/constants';

import HorizontalDividers from 'components/CustomDividers/HorizontalDividers';
import VerticalDividers from 'components/CustomDividers/VerticalDividers';
import WarningIcon from '@mui/icons-material/Warning';
import config from 'config';

interface FormValues {
  store_name: string;
  api_key: string;
  api_secret: string;
  program_id: string;
  catalog_id: string;
}

const TADAContent: React.FunctionComponent<DialogProps> = ({ handleClosePrimary, getListChannel }) => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<FormValues>();
  const { setShowConnectedPopup, disablePrevButton } = useAppStore();

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    try {
      let payload = {
        store_name: data.store_name,
        apiKey: data.api_key,
        apiSecret: data.api_secret,
        programId: data.program_id,
        catalogId: data.catalog_id
      };
      const res: any = await getTadaAuthorizeUrl(payload);
      if (res && res?.data && res?.data?.status == 'ok') {
        if (!disablePrevButton) {
          setShowConnectedPopup(true);
          getListChannel();
          handleClosePrimary();
        } else {
          location.replace(config.baseUrl);
        }
      } else {
        showAlert('error', `${res?.data?.message}`, 5000);
      }
    } catch (err) {
      const error = err as Error;
      showAlert('error', `${error}`, 5000);
    }
  };

  return (
    <DialogContentStyled>
      <LeftContentWrapper>
        <LeftContent channelId={channels.TADA} />
      </LeftContentWrapper>
      <VerticalDividers />
      <RightContentWrapper>
        <RightForm id="tada_form" onSubmit={handleSubmit(onSubmit)}>
          <InputGrid
            label={<Label>Nama Toko</Label>}
            input={
              <Input
                isError={errors.store_name?.message ? true : false}
                type={'text'}
                placeholder={'Masukkan Nama Toko'}
                {...register('store_name', {
                  required: { value: true, message: 'Nama Toko harus di isi' }
                })}
              />
            }
            errorMessage={
              errors?.store_name && (
                <ErrorMessage
                  icon={<WarningIcon fontSize="small" color="error" />}
                  message={errors.store_name.message}
                />
              )
            }
          />
          <InputGrid
            label={<Label className="requiredField">API Key</Label>}
            input={
              <Input
                isError={errors.api_key?.message ? true : false}
                type={'text'}
                placeholder={'API Key'}
                {...register('api_key', {
                  required: { value: true, message: 'API Key harus di isi' }
                })}
              />
            }
            errorMessage={
              errors?.api_key && (
                <ErrorMessage icon={<WarningIcon fontSize="small" color="error" />} message={errors.api_key.message} />
              )
            }
          />
          <InputGrid
            label={<Label className="requiredField">API Secret</Label>}
            input={
              <Input
                isError={errors.api_secret?.message ? true : false}
                type={'text'}
                placeholder={'API Secret'}
                {...register('api_secret', {
                  required: { value: true, message: 'API Secret harus di isi' }
                })}
              />
            }
            errorMessage={
              errors?.api_secret && (
                <ErrorMessage
                  icon={<WarningIcon fontSize="small" color="error" />}
                  message={errors.api_secret.message}
                />
              )
            }
          />
          <InputGrid
            label={<Label className="requiredField">Program ID</Label>}
            input={
              <Input
                isError={errors.program_id?.message ? true : false}
                type={'text'}
                placeholder={'App Key'}
                {...register('program_id', {
                  required: { value: true, message: 'Program ID harus di isi' }
                })}
              />
            }
            errorMessage={
              errors?.program_id && (
                <ErrorMessage
                  icon={<WarningIcon fontSize="small" color="error" />}
                  message={errors.program_id.message}
                />
              )
            }
          />
          <InputGrid
            label={<Label className="requiredField">Catalog ID</Label>}
            input={
              <Input
                isError={errors.catalog_id?.message ? true : false}
                type={'text'}
                placeholder={'App Secret'}
                {...register('catalog_id', {
                  required: { value: true, message: 'Catalog ID harus di isi' }
                })}
              />
            }
            errorMessage={
              errors?.catalog_id && (
                <ErrorMessage
                  icon={<WarningIcon fontSize="small" color="error" />}
                  message={errors.catalog_id.message}
                />
              )
            }
          />
        </RightForm>
        <Bottom>
          <HorizontalDividers />
          <BottomActions>
            <ConnectButton form="tada_form">Sambungkan</ConnectButton>
          </BottomActions>
        </Bottom>
      </RightContentWrapper>
    </DialogContentStyled>
  );
};

export default TADAContent;
